<tt-page class="col-xs-12 col-md-6 sp-0">
    <tt-card>
        <tt-button-goto [ttText]="'new_pricelist'" (ttClick)="goToFunc('pricelist')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListPrices"></tt-list>
</tt-page>
